import { DateType } from '@adminPortal/_common/_enums/date-type';
import { IComment } from '@adminPortal/_common/_interfaces/IComment';
import { IDesign } from '@adminPortal/_common/_interfaces/IDesign';
import { IPwaContent } from '@adminPortal/_common/_interfaces/IPwaContent';
import { IPwaPreviewConfig } from '@adminPortal/_common/_interfaces/IPwaPreviewConfig';
import { Component, effect, EventEmitter, input, Output } from '@angular/core';
import {
  CLASSIC_TEMPLATE_TEXTS,
  IClassicTemplateTranslations,
} from '@sharedLib/components/pwa-templates/classic-template/data/static-texts';
import { NgClass, NgIf } from '@angular/common';
import { ShortNumberPipe } from '@sharedLib/pipes/short-number.pipe';
import { ObjectToDatePipe } from '@sharedLib/pipes/object-to-date.pipe';
import { PlayerComponent } from '@sharedLib/components/player/player.component';
import { VimeoPlayerComponent } from '@sharedLib/components/vimeo-player/vimeo-player.component';
import { YoutubePlayerComponent } from '@sharedLib/components/youtube-player/youtube-player.component';

@Component({
  selector: 'pwa-modern-template',
  imports: [
    NgClass,
    ShortNumberPipe,
    ObjectToDatePipe,
    NgIf,
    PlayerComponent,
    VimeoPlayerComponent,
    YoutubePlayerComponent,
  ],
  templateUrl: './modern-template.component.html',
  styleUrl: './modern-template.component.scss',
})
export class ModernTemplateComponent {
  config = input.required<IPwaPreviewConfig>();
  contentLanguageCode = input<string>();
  installResult = input<string>();

  // variables for deployed app
  isAppInstalled = input<boolean>(false);
  isInitialization = input<boolean>(false);

  // variables for preview
  isPreviewMode = input<boolean>(false);
  designsList = input<IDesign[]>([]);

  @Output() open = new EventEmitter<boolean>();
  @Output() install = new EventEmitter<boolean>();

  public previewContent!: IPwaContent;
  public staticTexts!: IClassicTemplateTranslations;

  public starsAmountRate = Array.from({ length: 5 }, (_, i) => i);
  public starsChartBar = [
    { rate: 5, percentage: 100 },
    { rate: 4, percentage: 21 },
    { rate: 3, percentage: 2 },
    { rate: 2, percentage: 0.01 },
    { rate: 1, percentage: 0 },
  ];

  public isDescriptionPopupVisible = false;

  get previewYoutubeVideoId(): string {
    if (this.config().headerVideoUrl.includes('youtu.be')) {
      return this.config().headerVideoUrl.split('.be/')[1].split('?')[0];
    } else {
      return this.config().headerVideoUrl.split('v=')[1];
    }
  }

  get banners(): string[] {
    const config = this.config();
    return config.banners.map((el) => el.image);
  }

  get sortedComments(): IComment[] {
    let comments: IComment[] = [];
    const originalComments: IComment[] = structuredClone(this.previewContent.comments);
    if (this.previewContent.updateDate.type === DateType.RELATIVE) {
      comments = originalComments.sort((a, b) => (a.date.offsetInDays || 0) - (b.date.offsetInDays || 0));
    } else {
      comments = originalComments.sort(
        (a, b) => new Date(b.date.dateTime || 0).getTime() - new Date(a.date.dateTime || 0).getTime()
      );
    }
    return comments;
  }

  getArray(length: number): number[] {
    return Array(length)
      .fill(0)
      .map((_, i) => i);
  }

  constructor() {
    effect(() => {
      const config = this.config();
      const contentLanguageCode = this.contentLanguageCode();
      const previewContent = config.content.find((el) => el.languageCode === contentLanguageCode);
      const defaultPreviewContent = config.content.filter((el) => el.isDefault);

      if (contentLanguageCode) {
        this.staticTexts = CLASSIC_TEMPLATE_TEXTS[contentLanguageCode];
      } else if (defaultPreviewContent.length && CLASSIC_TEMPLATE_TEXTS[defaultPreviewContent[0].languageCode]) {
        this.staticTexts = CLASSIC_TEMPLATE_TEXTS[defaultPreviewContent[0].languageCode];
      } else if (CLASSIC_TEMPLATE_TEXTS[config.content[0].languageCode]) {
        this.staticTexts = CLASSIC_TEMPLATE_TEXTS[config.content[0].languageCode];
      }
      if (!this.staticTexts) {
        this.staticTexts = CLASSIC_TEMPLATE_TEXTS['en'];
      }

      if (previewContent) {
        this.previewContent = previewContent;
      } else if (defaultPreviewContent.length) {
        this.previewContent = defaultPreviewContent[0];
      } else {
        this.previewContent = config.content[0];
      }
    });
  }

  public togglePopup(type: 'description' | 'comments' = 'description') {
    if (type === 'description') {
      this.isDescriptionPopupVisible = !this.isDescriptionPopupVisible;
    }
  }

}
